<template>
  <div :class="{'app-user-proxy-access': userHasProxyAccess}">
    <slot />
  </div>          
</template>

<script>
export default {
  name: "BlankLayout",
  components: {},
  data() {
    return {
      title: ""
    };
  },
  computed: {
    userHasProxyAccess() {
      return this.$store.state.system.appUserProxyAccess
    },
  },
  mounted() {},
  methods: {}
};
</script>